import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { GetFormaPagamento } from "../../api/FormaPagamento/index";
import useAlert from "../../hooks/useAlert";
import List from "@mui/material/List";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { LoadingFormaPagamento } from "../";
import PixIcon from "@mui/icons-material/Pix";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import TiposLiquidacao from "../../util/typesTipoLiquidacao";
import TiposPedido from "../../util/typesTipoPedido";
import DadosBancarios from "../../components/DadosBancarios";
import { Box, Collapse } from "@mui/material";
import PaymentsIcon from "@mui/icons-material/Payments";
import CreditCardForm from "../CartaoCredito/CreditCard";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export default function OpcoesPagamento({
  idTipoPedido,
  onNext,
  loadingAddPagamento = false,
  idPraca,
  setSelectedFormaPagamento,
}) {
  const [itens, setItens] = useState(null);
  const [showCreditCard, setShowCreditCard] = useState(false);
  const { showAlertError } = useAlert();
  const [formaTedDoc, setformaTedDoc] = useState([]);
  const [expandedItems, setExpandedItems] = useState({});

  useQuery(
    `FORMAPAGEMENTOOPERACAO${idTipoPedido}`,
    () => GetFormaPagamento(idTipoPedido, idPraca),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (!data || !data?.data) {
          showAlertError(
            "Ops, ocorreu um erro, informe ao suporte tecnico o seguinte erro: Nenhuma forma de pagamento encontrada - RXKP1 "
          );
          return;
        }

        if (data.errorMessage) {
          showAlertError(
            `Ops, ocorreu um erro, informe ao suporte tecnico o seguinte erro: ${data.errorMessage} - RG7ZB `
          );
          return;
        }

        if (data.status) {
          setItens(() => data.data);
        }
      },
      onError: (error) => {
        showAlertError(
          `Ops, ocorreu um erro, informe ao suporte tecnico: ${error?.message} -  RI1K8`
        );
      },
    }
  );

  useEffect(() => {
    if (itens?.length > 0)
      setformaTedDoc(
        itens.filter(
          (i) =>
            i.tipoLiquidacao.id === TiposLiquidacao.Ted ||
            i.tipoLiquidacao.id === TiposLiquidacao.Doc
        )
      );
  }, [itens]);

  const handlerSelect = (event, formaPagamento) => {
    setSelectedFormaPagamento(() => formaPagamento);

    if (formaPagamento.tipoLiquidacao.id === TiposLiquidacao.CartaoCredito) {
      setShowCreditCard(() => true);
    } else {
      onNext(event, formaPagamento, idTipoPedido);
    }
  };

  const handlerSelectCard = (event) => {
    onNext(event, null, idTipoPedido);
  };

  const toggleExpand = (id, event) => {
    event.stopPropagation();
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const HtmlContent = ({ html }) => (
    <Box
      sx={{
        mt: 1,
        p: 2,
        backgroundColor: '#f8f9fa',
        borderRadius: 1,
        fontSize: '0.8rem',
        lineHeight: 1.5,
        color: '#555',
        '& p': { margin: '6px 0' },
        '& ul, & ol': { 
          margin: '6px 0',
          paddingLeft: '20px'
        },
        '& li': { margin: '3px 0' },
        '& strong': { color: '#000' },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
          margin: '10px 0 6px 0',
          fontSize: '0.85rem',
          fontWeight: '600'
        }
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );

  const getPaymentIcon = (tipoLiquidacaoId) => {
    switch (tipoLiquidacaoId) {
      case TiposLiquidacao.CartaoCredito:
        return <CreditCardIcon />;
      case TiposLiquidacao.Doc:
      case TiposLiquidacao.Ted:
        return <AccountBalanceIcon />;
      case TiposLiquidacao.Especie:
        return <PaymentsIcon />;
      case TiposLiquidacao.Pix:
        return <PixIcon />;
      default:
        return <PaymentsIcon />;
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          maxHeight: "50vh",
          overflowY: "auto",
          overflowX: "hidden",
          bgcolor: "background.paper",
        }}
      >
        {!loadingAddPagamento &&
          (idTipoPedido === TiposPedido.Recebimento ||
            idTipoPedido === TiposPedido.CompraEspecie) && (
            <DadosBancarios isOperacao={true} onNext={onNext} />
          )}
      </Box>
      
      {!showCreditCard ? (
        <Box sx={{ width: "100%", maxWidth: "100%" }}>
          {!loadingAddPagamento && itens ? (
            <>
              {itens.map((f, index) => (
                <Box key={f.id || index}>
                  {idTipoPedido === TiposPedido.Recebimento ||
                   idTipoPedido === TiposPedido.CompleEspecie ? (
                    f.tipoLiquidacao.id !== TiposLiquidacao.Ted &&
                    f.tipoLiquidacao.id !== TiposLiquidacao.Doc && (
                      <Box 
                        sx={{ 
                          p: 2, 
                          mb: 1,
                          backgroundColor: '#fcfcfc',
                          borderRadius: 1,
                          cursor: 'pointer',
                          '&:hover': { backgroundColor: '#f5f5f5' }
                        }}
                        onClick={(event) => onNext(event, f, idTipoPedido)}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <ListItemIcon sx={{ minWidth: 40, color: '#666' }}>
                            {getPaymentIcon(f.tipoLiquidacao.id)}
                          </ListItemIcon>
                          <Typography variant="body1" fontWeight="500" sx={{ flex: 1 }}>
                            {f.descricao}
                          </Typography>
                          <ArrowForwardIosIcon sx={{ color: "#666", fontSize: 14 }} />
                        </Box>
                      </Box>
                    )
                  ) : (
                    <Box 
                      sx={{ 
                        p: 2, 
                        mb: 1,
                        backgroundColor: '#fcfcfc',
                        borderRadius: 1,
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: '#f5f5f5' }
                      }}
                      onClick={(event) => handlerSelect(event, f)}
                    >
                      {/* Cabeçalho principal */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <ListItemIcon sx={{ minWidth: 40, color: '#666', mt: 0.25 }}>
                          {getPaymentIcon(f.tipoLiquidacao.id)}
                        </ListItemIcon>
                        
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography variant="body1" fontWeight="500" sx={{ mb: 0.5 }}>
                            {f.descricao}
                          </Typography>
                          
                          {/* Área clicável separada para detalhes */}
                          {f.descricaoHtml && (
                            <Box 
                              sx={{ 
                                display: 'inline-flex', 
                                alignItems: 'center',
                                p: 0.5,
                                borderRadius: 0.5,
                                '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                              }}
                              onClick={(e) => toggleExpand(f.id, e)}
                            >
                              <Typography
                                variant="body2"
                                color="primary"
                                sx={{ 
                                  cursor: 'pointer',
                                  fontSize: '0.8rem'
                                }}
                              >
                                {expandedItems[f.id] ? 'Ocultar detalhes' : 'Ver detalhes'}
                              </Typography>
                              {expandedItems[f.id] ? (
                                <ExpandLessIcon sx={{ fontSize: 16, ml: 0.5, color: 'primary.main' }} />
                              ) : (
                                <ExpandMoreIcon sx={{ fontSize: 16, ml: 0.5, color: 'primary.main' }} />
                              )}
                            </Box>
                          )}
                        </Box>

                        <ArrowForwardIosIcon 
                          sx={{ 
                            color: "#666", 
                            fontSize: 14, 
                            ml: 1,
                            mt: 0.25
                          }} 
                        />
                      </Box>

                      {/* Conteúdo HTML expandível */}
                      {f.descricaoHtml && (
                        <Collapse in={expandedItems[f.id]} timeout="auto">
                          <Box sx={{ mt: 1.5, ml: 5 }}>
                            <HtmlContent html={f.descricaoHtml} />
                          </Box>
                        </Collapse>
                      )}
                    </Box>
                  )}
                </Box>
              ))}
            </>
          ) : (
            <LoadingFormaPagamento />
          )}
        </Box>
      ) : (
        <CreditCardForm
          closeModal={() => setShowCreditCard(() => false)}
          onSelectCard={handlerSelectCard}
          idTipoPedido={idTipoPedido}
        />
      )}
    </>
  );
}